import { useEffect, useState } from "react";
import { GoabContainer } from "@abgov/react-components";

import { useSessionManagement, useGenerationForm } from "../../hooks";

import FamilyMembers from "../../../../../MPP-Common-SPA/Widgets/FamilyMembers/FamilyMembers";

export const FamilyMembersSection = () => {
  const { form, getRefData } = useGenerationForm();

  const { getResourceValue } = useSessionManagement();

  // Key use to reset Family Members state on reset
  const [componentKey, setComponentKey] = useState(0);

  // Checks for form values to be reset and updates the key
  useEffect(() => {
    const familyMembers = form.values.FamilyMembers?.familyMembers || [];
    if (familyMembers.length === 0) {
      setComponentKey((key) => key + 1);
    }
  }, [form.values.FamilyMembers?.familyMembers]);

  // Create setFormData function to update form values to be used in FamilyMembers
  const setFormData = (formValue: any) => {
    if (formValue.familyMembers) {
      form.setFieldValue(
        "FamilyMembers.familyMembers",
        formValue.familyMembers
      );
    }
    if (formValue.acceptLegalRepresentative !== undefined) {
      form.setFieldValue(
        "FamilyMembers.acceptLegalRepresentative",
        formValue.acceptLegalRepresentative
      );
    }
  };

  // Form wrapper that uses generator values in the component.
  const familyMembersForm = {
    ...form,
    values: {
      ...form.values,
      familyMembers: form.values.FamilyMembers?.familyMembers || [],
      acceptLegalRepresentative:
        form.values.FamilyMembers?.acceptLegalRepresentative || false,
    },
    setValues: (values: any) => {
      form.setFieldValue("FamilyMembers.familyMembers", values.familyMembers);
      form.setFieldValue(
        "FamilyMembers.acceptLegalRepresentative",
        values.acceptLegalRepresentative
      );
    },
  };
  const gaTracking = [
    {
      "event": "add_family_member_button",
      "paramKey": "add_family_member_button_step",
      "trackingField": "add_family_member_button_clicked"
    },
    {
      "event": "add_another_family_member_button",
      "paramKey": "add_another_family_member_button_step",
      "trackingField": "add_another_family_member_button_clicked"
    }
  ]

  return (
    <>
      <GoabContainer accent="thin">
        <h3>
          {getResourceValue({ key: "RESOURCES@familyMembers.header.title" })}
        </h3>
        <FamilyMembers
          key={componentKey}
          form={familyMembersForm}
          getResourceValue={getResourceValue}
          getRefData={getRefData}
          setFormData={setFormData}
          setShowStepActionButtons={false}
          isGenerator={true}
          gaTracking={gaTracking}
        />
      </GoabContainer>
    </>
  );
};
